import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=050d4697&scoped=true&"
import script from "./inform.vue?vue&type=script&lang=js&"
export * from "./inform.vue?vue&type=script&lang=js&"
import style0 from "./inform.vue?vue&type=style&index=0&id=050d4697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050d4697",
  null
  
)

export default component.exports